import { Skeleton, Stack, Grid2 as Grid } from "@mui/material";

export function DocumentoElectronicoSkeleton() {
    return (
        <Stack gap={2} sx={{ flex: 1 }}>
            <Stack gap={1.5}>
                <Skeleton variant="text" width={150} height={24} />
                
                <Stack direction={{ xs: 'column', sm: 'row' }} gap={1.5} alignItems="flex-start" flexWrap="wrap">
                    <Skeleton variant="rectangular" width={200} height={40} />
                    <Skeleton variant="rectangular" width={200} height={40} />
                    <Skeleton variant="rectangular" width={200} height={40} />
                </Stack>
                
                <Stack direction={{ xs: 'column', sm: 'row' }} gap={1.5} alignItems="flex-start" flexWrap="wrap">
                    <Skeleton variant="rectangular" width={200} height={40} />
                    <Skeleton variant="rectangular" width={200} height={40} />
                    <Skeleton variant="rectangular" width={200} height={40} />
                </Stack>
                
                <Stack direction={{ xs: 'column', sm: 'row' }} gap={1.5} alignItems="flex-start" flexWrap="wrap">
                    <Skeleton variant="rectangular" width={200} height={40} />
                    <Skeleton variant="rectangular" width={200} height={40} />
                </Stack>
            </Stack>

            <Grid container columns={{ xs: 1, md: 3 }} spacing={2} flex={1}>
                <Grid size={1}>
                    <Stack gap={2}>
                        <Skeleton variant="text" width={120} height={24} />
                        
                        <Skeleton variant="rectangular" width="100%" height={40} />
                        
                        <Stack direction="row" gap={2}>
                            <Skeleton variant="rectangular" width={80} height={40} />
                            <Skeleton variant="rectangular" width={100} height={40} />
                            <Stack gap={1}>
                                <Skeleton variant="text" width={30} height={16} />
                                <Stack direction="row" gap={1}>
                                    <Skeleton variant="circular" width={20} height={20} />
                                    <Skeleton variant="text" width={50} height={16} />
                                    <Skeleton variant="circular" width={20} height={20} />
                                    <Skeleton variant="text" width={30} height={16} />
                                </Stack>
                            </Stack>
                        </Stack>
                        
                        <Skeleton variant="rectangular" width={120} height={36} />
                    </Stack>
                </Grid>

                <Grid size={2}>
                    <Stack gap={1} flex={1}>
                        <Skeleton variant="text" width={100} height={24} />
                        
                        <Stack direction="row" gap={1} sx={{ py: 1, borderBottom: '1px solid #e0e0e0' }}>
                            <Skeleton variant="text" width={30} height={20} />
                            <Skeleton variant="text" width={150} height={20} />
                            <Skeleton variant="text" width={80} height={20} />
                            <Skeleton variant="text" width={60} height={20} />
                            <Skeleton variant="text" width={80} height={20} />
                            <Skeleton variant="text" width={100} height={20} />
                            <Skeleton variant="text" width={40} height={20} />
                        </Stack>
                        
                        {[1, 2].map((i) => (
                            <Stack key={i} direction="row" gap={1} sx={{ py: 0.5 }}>
                                <Skeleton variant="text" width={30} height={20} />
                                <Skeleton variant="text" width={150} height={20} />
                                <Skeleton variant="text" width={80} height={20} />
                                <Skeleton variant="text" width={60} height={20} />
                                <Skeleton variant="text" width={80} height={20} />
                                <Skeleton variant="text" width={100} height={20} />
                                <Skeleton variant="rectangular" width={24} height={24} />
                            </Stack>
                        ))}
                        
                        <Stack direction="row" gap={1} sx={{ py: 1, borderTop: '1px solid #e0e0e0', mt: 'auto' }}>
                            <Skeleton variant="text" width={60} height={20} />
                            <Skeleton variant="text" width={80} height={20} sx={{ ml: 'auto' }} />
                        </Stack>
                    </Stack>
                </Grid>
            </Grid>

            <Stack direction="row" gap={2} justifyContent="flex-end">
                <Skeleton variant="rectangular" width={150} height={36} />
                <Skeleton variant="rectangular" width={80} height={36} />
            </Stack>
        </Stack>
    );
}
